import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "whitelist-container"
};
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = {
  class: "whitelist-content"
};
const _hoisted_4 = {
  class: "back-button-wrapper"
};
const _hoisted_5 = {
  class: "status-animation"
};
const _hoisted_6 = {
  class: "status-icon"
};
const _hoisted_7 = {
  class: "status-badge"
};
const _hoisted_8 = {
  class: "status-info"
};
const _hoisted_9 = {
  class: "status-title"
};
const _hoisted_10 = {
  class: "status-description"
};
const _hoisted_11 = {
  class: "status-actions"
};
const _hoisted_12 = {
  class: "help-info"
};
const _hoisted_13 = {
  class: "help-text"
};
const _hoisted_14 = {
  class: "quick-links"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "background-wrapper",
    innerHTML: _ctx.backgroundImagesTemplate
  }, null, 8, _hoisted_2), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
    class: "back-button",
    onClick: $options.goHome,
    circle: "",
    size: "large"
  }, {
    default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
      icon: "home"
    })]),
    _: 1
  }, 8, ["onClick"])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_font_awesome_icon, {
    icon: "shield-alt",
    class: "shield-icon"
  }), _createElementVNode("div", _hoisted_7, [_createVNode(_component_font_awesome_icon, {
    icon: "clock",
    class: "clock-icon"
  })])])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("h1", _hoisted_9, _toDisplayString(_ctx.$t('whitelist.title')), 1), _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('whitelist.description')), 1), _createElementVNode("div", _hoisted_11, [_createVNode(_component_el_button, {
    type: "primary",
    size: "large",
    class: "action-btn primary-btn",
    onClick: $options.goHome
  }, {
    default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
      icon: "home",
      class: "btn-icon"
    }), _createTextVNode(" " + _toDisplayString(_ctx.$t('whitelist.goHome')), 1)]),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_el_button, {
    size: "large",
    class: "action-btn secondary-btn",
    onClick: $options.goBack
  }, {
    default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
      icon: "arrow-left",
      class: "btn-icon"
    }), _createTextVNode(" " + _toDisplayString(_ctx.$t('whitelist.goBack')), 1)]),
    _: 1
  }, 8, ["onClick"])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t('whitelist.helpText')), 1), _createElementVNode("div", _hoisted_14, [_createElementVNode("a", {
    href: "javascript:void(0)",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.goHome && $options.goHome(...args)),
    class: "quick-link"
  }, [_createVNode(_component_font_awesome_icon, {
    icon: "cloud-upload-alt"
  }), _createTextVNode(" " + _toDisplayString(_ctx.$t('whitelist.uploadImage')), 1)]), _createElementVNode("a", {
    href: "javascript:void(0)",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.refreshPage && $options.refreshPage(...args)),
    class: "quick-link"
  }, [_createVNode(_component_font_awesome_icon, {
    icon: "redo"
  }), _createTextVNode(" " + _toDisplayString(_ctx.$t('whitelist.refreshPage')), 1)])])]), _cache[2] || (_cache[2] = _createElementVNode("div", {
    class: "powered-by"
  }, [_createElementVNode("p", null, [_createTextVNode("Powered By: "), _createElementVNode("a", {
    href: "https://github.com/MarSeventh/CloudFlare-ImgBed",
    class: "project-link"
  }, " CloudFlare-ImgBed ")])], -1))])]), _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"floating-elements\" data-v-46822ec2><div class=\"floating-shape shape-1\" data-v-46822ec2></div><div class=\"floating-shape shape-2\" data-v-46822ec2></div><div class=\"floating-shape shape-3\" data-v-46822ec2></div><div class=\"floating-shape shape-4\" data-v-46822ec2></div><div class=\"floating-shape shape-5\" data-v-46822ec2></div></div>", 1))]);
}